import React from 'react';
import {
    Button, Tag, Form, Radio, Select, DatePicker, TimePicker, Input, InputNumber,
    Switch, Image
} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {NavLink} from 'react-router-dom'
import {useTranslation} from 'react-i18next';
import PolygonMapComponent from './PolygonMapComponent';
import PhotoComponent from './PhotoComponent';
import config from '../business/config.json';
import BusinessFieldComponent from '../business/components/BusinessFieldComponent';

const {TextArea} = Input;
const {Option} = Select;
const mysqlDateFormat = "YYYY-MM-DD hh:mm:ss";
const IMAGE_DIR = config.api_domain + "/business/database/";

function FieldComponent(props) {
    const {t} = useTranslation();

    const urlAddonBefore = (
        <Select defaultValue="http://" className="select-before">
            <Option value="http://">http://</Option>
            <Option value="https://">https://</Option>
        </Select>
    );
    const phoneAddonBefore = (
        <Select defaultValue="+61" className="select-before">
            <Option value="+61">+61</Option>
        </Select>
    );
    const core_fields = {
        text: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input key={field}/>),
            view: field => (<>{field}</>)
        },
        password: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input.Password key={field}/>),
            view: field => (<b>*****</b>)
        },
        email: {
            rules: {
                type: "email",
                message: t("Insert valid email")
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input key={field}/>),
            view: field => (<><a rel="noopener noreferrer" href={"mailto:" + field}>{field}</a></>)
        },
        phone: {
            rules: {
                max: 15,
                type: "regexp",
                pattern: new RegExp(/\d+/g)
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input addonBefore={phoneAddonBefore} key={field}/>),
            view: field => (<a rel="noopener noreferrer" href={"phone:" + field}>{field}</a>)
        },
        url: {
            rules: {
                type: "url"
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input addonBefore={urlAddonBefore} key={field}/>),
            view: field => (<a rel="noopener noreferrer" target="_blank" href={field}>{field}</a>)
        },
        textarea: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input.TextArea key={field}/>),
            view: field => (<>{field}</>)
        },
        hidden: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value",
                hidden: true
            },
            element: (field) => (<Input key={field}/>),
            view: field => (<>{field}</>)
        },
        number: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
            },
            element: (field) => (<InputNumber key={field}/>),
            view: field => (<>{field}</>)
        },
        checkbox: {
            rules: {
                type: "boolean"
            },
            props: {
               currentproject: props.id,
                valuePropName: "checked",
            },
            element: (field) => (<Switch key={field}/>),
            view: field => (<Tag color={field ? "blue" : "#666"}>{field ? "TRUE" : "FALSE"}</Tag>)
        },
        question: {
            rules: {
                type: "boolean"
            },
            props: {
               currentproject: props.id,
                valuePropName: "checked"
            },
            element: (field) => (<Switch checkedChildren={t("Yes")} unCheckedChildren={t("No")} key={field}/>),
            view: field => (<Tag color={field ? "blue" : "#666"}>{field ? t("Yes") : t("No")}</Tag>)
        },
        "switch": {
            rules: {
                type: "boolean"
            },
            props: {
               currentproject: props.id,
                valuePropName: "checked"
            },
            element: (field) => (<Switch checkedChildren="On" unCheckedChildren="Off" key={field}/>),
            view: field => (<Tag color={field ? "blue" : "#666"}>{field ? "On" : "Off"}</Tag>)
        },
        logical: {
            rules: {
                type: "boolean"
            },
            props: {
               currentproject: props.id,
                valuePropName: "checked"
            },
            element: (field) => (<Switch checkedChildren="TRUE" unCheckedChildren="FALSE" key={field}/>),
            view: field => (<Tag color={field ? "blue" : "#666"}>{field ? "TRUE" : "FALSE"}</Tag>)
        },
        select: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Select key={field}></Select>),
            view: field => (<>{field}</>)
        },
        radio: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Radio.Group key={field}></Radio.Group>),
            view: field => (<>{field}</>)
        },
        color: {
            rules: {
                type: "regex",
                pattern: new RegExp(/[ABCDEF,0-9]*/),
                max: 6
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input key={field}/>),
            view: field => (<Tag color={field}>{field}</Tag>)
        },
        icon: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field) => (<Input key={field}/>),
            view: field => (<>{field}</>)
        },
        time: {
            rules: {
                type: "date"
            },
            props: {
               currentproject: props.id,
            },
            element: (field) => (<TimePicker key={field}/>),
            view: field => (<>{field}</>)
        },
        date: {
            rules: {
                type: "date"
            },
            props: {
               currentproject: props.id,
            },
            element: (field) => (<DatePicker showTime={false} format={mysqlDateFormat} key={field}/>),
            view: field => (<>{field}</>)
        },
        datetime_local: {
            rules: {
                type: "date"
            },
            props: {
               currentproject: props.id,
            },
            element: (field) => (<DatePicker showNow={false} showTime={true} format={mysqlDateFormat} key={field}/>),
            view: field => (<>{field}</>)
        },
        file: {},
        image: {
            rules: {
                type: "string"
            },
            props: {
               currentproject: props.currentproject,
                valuePropName: "value"
            },
            element: (field, options) => (<PhotoComponent dir={IMAGE_DIR} entity={options.entity} key={field} currentproject={props.currentproject} />),
            view: field => (
                <Image
                    fallback={config.fallback_image}
                    height={"100px"}
                    width={"100px"}
                    src={field}
                />
            )
        },
        address: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        polygon: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<TextArea disabled={props.disabled} rows={4} key={field}/>),
            view: field => (<>{field}</>)
        },
        latitude: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input disabled={props.disabled} key={field}/>),
            view: field => (<>{field}</>)
        },
        longitude: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        postcode: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        region: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        city: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        suburb: {
            rules: {},
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (<Input key={field} disabled={props.disabled}/>),
            view: field => (<>{field}</>)
        },
        latlng_polygon_map: {
            rules: {
                type: "object"
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => (
                <PolygonMapComponent key={field} onChange={options.onChange}/>
            ),
            view: field => (
                <PolygonMapComponent caption={true} view={true} key={field} value={props.value}/>
            )
        },
        arrow_x: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
            },
            element: (field, options) => (<InputNumber key={field} disabled={options.disabled}/>),
            view: field => (<>{field}</>)
        },
        arrow_y: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
            },
            element: (field, options) => (<InputNumber key={field} disabled={options.disabled}/>),
            view: field => (<>{field}</>)
        },
        arrow_angle: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
            },
            element: (field, options) => (<InputNumber key={field} disabled={options.disabled}/>),
            view: field => (<>{field}</>)
        },
        document_link: {
            rules: {},
            element: (field) => (<span>{props.value}</span>),
            props: {
                currentproject: props.id
            },
            view: (field) => (
                <Button disabled={field === null}>
                    <NavLink to={field ? field : "#"}>
                        <FontAwesomeIcon icon="file"/>&nbsp;See Document
                    </NavLink>
                </Button>
            )
        },
        foreign_key: {
            rules: {
                type: "number"
            },
            props: {
               currentproject: props.id,
                valuePropName: "value"
            },
            element: (field, options) => {
                if (Array.isArray(options.foreignList) === false) {
                    return (
                        <Select key={field} disabled={options.disabled} style={{width: '50%'}}>
                            <Select.Option value={null}>{t("(None)")}</Select.Option>
                        </Select>
                    );
                }
                return (
                    <Select key={field} disabled={options.disabled} style={{width: '50%'}}>
                        <Select.Option value={null}>{t("(None)")}</Select.Option>
                        {options.foreignList.map((option) => (
                            <Select.Option
                                key={option.id}
                                value={option.id}
                            >
                                {option.display_field}
                            </Select.Option>
                        ))}
                    </Select>
                );
            },
            view: field => (<>{field}</>)
        }
    };

    const fields = Object.assign({}, core_fields, BusinessFieldComponent);

    if (props.view === true) {
        return (
            <>
                {fields[props.fieldtype].view(props.value, props.field)}
            </>
        );
    }

    return (
        <>
            <Form.Item
                colon={true}
                label={props.name}
                key={props.field}
                name={props.field}
                style={{
                    display: (props.hidden ? "none" : "")
                }}
                rules={[
                    {
                        required: props.required,
                        message: t("Please complete this field")
                    },
                    {...fields[props.fieldtype].rules}
                ]}
                {...fields[props.fieldtype].props}
            >
                {fields[props.fieldtype].element(props.field, props)}
            </Form.Item>
        </>
    );
}

export default FieldComponent;
